import { render, staticRenderFns } from "./InspectionModalImages.vue?vue&type=template&id=bc278ac4&"
import script from "./InspectionModalImages.vue?vue&type=script&lang=ts&"
export * from "./InspectionModalImages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports